export enum AuthUrl {
  LOGOUT = '/auth/logout',
  USER_INFO = '/auth/user-info',
  PERMISSION = '/auth/permission/{permissionCode}{?groupId,groupCode,descriptionId,descriptionCode,versionId}',
}
